import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as PXBColors from '@brightlayer-ui/colors';

const userStyles = makeStyles((theme: Theme) =>
    createStyles({
        addIcon: {
            height: 35,
            width: 35,
            marginRight: 20,
            marginTop: 5,
            cursor: 'pointer',
        },
        addUserIconDiv: {
            float: 'right',
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
        },
        IconStyle: {
            height: 30,
            width: 30,
            marginRight: 10,
        },
        addUserFormIcon: {
            height: '36px',
            width: '50px',
            marginTop: 15,
        },
        inviteUserButton: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: 20,
            paddingRight: 10,
        },
        addUserformControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: '50%',
        },
        formDiv: {
            flexGrow: 1,
        },
        serachDiv: {
            backgroundColor: 'white',
            marginBottom: 20,
        },
        visuallyHiddenArrow: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
        },
        largeIcon: {
            width: 60,
            height: 60,
        },
        WordBreak: {
            wordBreak: 'break-all',
            wordWrap: 'break-word',
        },
        marginTop40: { marginTop: 40 },
        toastPosition: { marginBottom: 5, marginTop: '-10px' },
        transparentBackground: { backgroundColor: 'transparent' },
        loadingButton: {
            height: 40,
            marginRight: 15,
            backgroundColor: PXBColors.blue[200],
            color: 'white',
        },
        listLineHeight: { lineHeight: 1.25 },
        fontWeight600: { fontWeight: 600 },
        mariginBottom20: { marginBottom: 20 },
        mariginRight15: { marginRight: 15 },
        avatarColor: {
            backgroundColor: PXBColors.blue[400],
            color: PXBColors.white[500],
        },
        margin20: { margin: 20 },
        iconPosition: {
            marginTop: 24, marginRight: 24
        },
        iconVisibilityHidden: {
            visibility: 'hidden'
        },
        iconVisibility: {
            visibility: 'visible'
        },
        paddingTextbox: {
            padding: '16px 8px'
        },
        padding8: {
            padding: 8
        },
        paddingTop0: {
            paddingTop: 0
        },
        paddingBottom24: {
            paddingBottom: 24
        }

    })
);
export default userStyles;
